import e from "./TooltipTrigger_vue.js";
//#region src/components/ui/tooltip/core/TooltipTrigger.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=TooltipTrigger.js.map